var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadingUniverseEnvironment)?_c('StLogin',{attrs:{"loading":_vm.loading,"i18n":_vm.i18n},on:{"login":_vm.login}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }